class AptRatingsController {
  static bindings = {
    max: '<',
    current: '<',
    iconClass: '@'
  };

  max;
  current;
  iconClass;

  ratingArray;

  constructor() {
    'ngInject';
  }

  $onInit() {
    this.iconClass = this.iconClass || 'ss-star';
    this.max = this.max || 5;
    this.current = this.current || 0;
    this.ratingArray = new Array(this.max);
  }
}

export const AptRatingsComponent = {
  controller: AptRatingsController,
  bindings: AptRatingsController.bindings,
  template: `<i ng-class="[{'filled': ($index+1) <= $ctrl.current}]"
              ng-repeat="rating in $ctrl.ratingArray track by $index"
              class="{{$ctrl.iconClass}}"></i>`
};
